import { Controller } from "@hotwired/stimulus"

// Fetches a Turbo Stream URL when a select changes, rendering the result.
// Usage: data-controller="remote-filter"
//        data-action="change->remote-filter#fetch"
//        data-remote-filter-url-value="/some/path"
//        data-remote-filter-param-value="selected_grupo" (query param name)
export default class extends Controller {
  static values = { url: String, param: String }

  fetch(event) {
    const value = event.target.value
    const param = this.paramValue || "selected"
    const url = `${this.urlValue}?${encodeURIComponent(param)}=${encodeURIComponent(value)}`

    window.fetch(url, { headers: { Accept: "text/vnd.turbo-stream.html" } })
      .then(r => r.text())
      .then(html => Turbo.renderStreamMessage(html))
  }
}
